"use strict";

/* global hubspot */
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _defer = _interopRequireDefault(require("q/js/lib/defer"));

var _default = (0, _memoize.default)(function (moduleName) {
  var defer = (0, _defer.default)();

  hubspot.require([moduleName], function (Module) {
    return defer.resolve(Module);
  });

  return defer.promise;
});

exports.default = _default;
module.exports = exports.default;